import { Changelog } from '@geartrack/shared-lib/dist/changelog/changelog'
import useSWRImmutable from 'swr/immutable'
import useFunctionsSWRFetcher from './util/useFunctionsSWRFetcher'

const useChangelog = (limit: number = 7) => {
  const fetcher = useFunctionsSWRFetcher<Changelog>()

  return useSWRImmutable(
    [
      'getHeadwayChangelog',
      {
        limit,
      },
    ],
    fetcher
  )
}

export default useChangelog
